import moment from 'moment'
import { get } from 'lodash'
export const extractModuleRole = (staffs, module, schoolId) => {
  const data = [...staffs]
  data.forEach((staff) => {
    staff.activeRole = _.find(staff.user.moduleRoles[module], (role) => {
      return role.schoolId === schoolId && (!role.endDate || moment(role.endDate).isSameOrAfter(moment(new Date())))
    })
  })
  return data
}

export const isHasRoleInHQ = (personalProfiles, rootGetters, moduleName, roleName) => {
  const inSchoolIds = personalProfiles.map((profile) => profile.school.id)
  for (let i = 0; i < personalProfiles.length; i += 1) {
    const foundMatchRole = get(personalProfiles[i], 'user.userRoles', [])?.find(
      (role) =>
        role.module === moduleName && role.name === roleName && !role.endDate && inSchoolIds.includes(role.schoolId)
    )
    if (foundMatchRole) {
      const schoolIdOfMatchRole = get(personalProfiles[i], 'school.id')
      const findChildrenSchool = (school) => {
        if (school.id === rootGetters['school/schoolId']) return true
        else if (school.children) {
          for (let childSchoolIndex = 0; childSchoolIndex < school.children.length; childSchoolIndex += 1) {
            if (findChildrenSchool(school.children[childSchoolIndex])) return true
          }
        }
        return false
      }
      const foundSchool = rootGetters['school/schoolTree']?.find((school) => school.id === schoolIdOfMatchRole)
      if (foundSchool) {
        const result = findChildrenSchool(foundSchool)
        if (result) return result
      }
    }
  }
  return false
}
